var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close_circle_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1423 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3697",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(1423 5)",
    style: {
      fill: "#f5f6fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1431 13)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1437.4 32-1.4-1.4 5.6-5.6-5.6-5.6 1.4-1.4 5.6 5.6 5.6-5.6 1.4 1.4-5.6 5.6 5.6 5.6-1.4 1.4-5.6-5.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleBlack);
export default __webpack_public_path__ + "static/media/close_circle_black.0bb96485b313b88a490241c6919da518.svg";
export { ForwardRef as ReactComponent };